export const ONE_MB = 1024 * 1024;
export const MAX_PDF_UPLOAD_BYTES = 10 * ONE_MB;
